<div class="modal-header">
    <h2 class="modal-title">Purchase Order Shipping Address</h2>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body">
            <dx-form *ngIf="address" [formData]="address" validationGroup="mainValidationGroup">
                <dxi-item itemType="group">
                    <dxi-item dataField="name"></dxi-item>
                    <dxi-item dataField="companyName"></dxi-item>
                    <dxi-item dataField="address1"></dxi-item>
                    <dxi-item dataField="address2"></dxi-item>
                    <dxi-item dataField="city"></dxi-item>
                    <dxi-item dataField="state"></dxi-item>
                    <dxi-item dataField="zip"></dxi-item>
                    <dxi-item dataField="phone"></dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-danger" (click)="save()">Save</button>
    <button class="btn btn-success" (click)="close()">Close</button>
</div>
